import { useLayoutEffect, useState } from 'react'

/**
 * 要素の高さ（px）を測り、リサイズのたびに測り直す。
 * 返した `ref` を要素に渡す。要素が描画されていないときの高さは undefined になる。
 */
export const useElementHeight = () => {
  const [element, setElement] = useState<HTMLElement | null>(null)
  const [height, setHeight] = useState<number>()

  useLayoutEffect(() => {
    if (!element) return

    const measure = () => {
      setHeight(element.offsetHeight)
    }
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(element)
    return () => observer.disconnect()
  }, [element])

  return { ref: setElement, height: element ? height : undefined }
}
